import { Canvas } from "@react-three/fiber";
import { Physics } from "@react-three/cannon";
import Scene from "./Scene";
import { useState, useEffect, use } from "react";
import { useFrame } from '@react-three/fiber';
import "./App.css";

export default function Flipping() {
  const [face, setFace] = useState(null);
  const [streak, setStreak] = useState(0);
  const [lastFace, setLastFace] = useState(null);
  const [locked, setLocked] = useState(false);

  const [coinColor, setCoinColor] = useState("gold");
  const [headsType, setHeadsType] = useState("default");
  const [tailsType, setTailsType] = useState("default");

  // await coin land
  useEffect(() => {
    const handler = (e) => setLocked(e.detail);
    document.addEventListener("coin-locked", handler);
    return () => document.removeEventListener("coin-locked", handler);
  }, []);

  // Handle Flip Result
  const handleResult = (resultFace) => {
    const newStreak = resultFace === lastFace ? streak + 1 : 1;
    setFace(resultFace);
    setStreak(newStreak);
    setLastFace(resultFace);
  };

  const flipCoin = () => {
    document.dispatchEvent(new Event("flip-coin"));
  };

  // useEffect((_, delta) => console.log(delta));

  //camera position, [0, 6, 10], [side rotation, up/down rotation, forward/back transforming], fov 60
  return (
    <div style={{ width: "70vw", height: "40vh", maxWidth: 500, background: "transparent", position: "relative" }}>
      <Canvas shadows camera={{ position: [0, 5, 8], fov: 60 }}>
        <Physics fixedStep={true} iterations={20} gravity={[0, -9.81, 0]}>
          <Scene
            onResult={handleResult}
            coinColor={coinColor}
            headsType={headsType}
            tailsType={tailsType}
          />
        </Physics>
      </Canvas>

      {/* 🎯 HTML UI Overlay (unchanged) */}
      <div
        style={{
          position: "absolute",
          bottom: "40px",
          left: "50%",
          transform: "translateX(-50%)",
          color: "white",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          userSelect: "none",
        }}
      >
        {/* Flip Button */}
        <button
          onClick={flipCoin}
          disabled={locked}
          style={{
            padding: "12px 24px",
            fontSize: "18px",
            background: locked ? "#777" : "plum",
            color: "black",
            border: "none",
            borderRadius: "8px",
            cursor: locked ? "not-allowed" : "pointer",
            fontWeight: "bold",
          }}
        >
          {locked ? "Flipping..." : "Flip Coin"}
        </button>
      </div>
    </div>
  );
}
